"use strict";
var race_1 = require('../operator/race');
exports.race = race_1.raceStatic;
//# sourceMappingURL=race.js.map